import { registerBlockType } from '@wordpress/blocks'
import { __ } from '@wordpress/i18n'
import {
	useBlockProps,
	InnerBlocks,
	InspectorControls,
	__experimentalBlock as Block
} from '@wordpress/block-editor'
import { PanelBody, RangeControl, SelectControl } from '@wordpress/components'
import { Component } from '@wordpress/element'

registerBlockType('wp-bootblock/alert', {
	apiVersion: 2,
	title: __('Alert – Bootblock ', 'wp-bootblock'),
	description: __('Block to show a virtual tour.', 'wp-bootblock'),
	keywords: [],
	icon: 'images-alt',
	category: 'media',
	supports: {
		alignWide: true,
		align: ['full']
	},
	attributes: {},
	// edit: (props) => {
	edit: class extends Component {

		constructor() {
			super(...arguments)
			this.state = {}
		}

		render() {
			const {
				attributes: {}
			} = this.props

			const onChangeHeight = (newHeight) => {
				this.props.setAttributes({
					height: newHeight
				})
			}

			return (
				<>
					{/*<BlockControls>*/}
					{/*</BlockControls>*/}
					<InspectorControls>
						<PanelBody title={__('Settings', 'wp_virtualtour')}>
							{/*<RangeControl*/}
							{/*	label="Height"*/}
							{/*	value={height}*/}
							{/*	onChange={onChangeHeight}*/}
							{/*	min={0}*/}
							{/*	max={1000}*/}
							{/*/>*/}
							{/*<SelectControl*/}
							{/*	label={__('Select tour', 'wp_virtualtour')}*/}
							{/*	value={id}*/}
							{/*	onChange={onChangeTour}*/}
							{/*	options={getTourOptions()}*/}
							{/*/>*/}
						</PanelBody>
					</InspectorControls>
					<Block.div>
						<div className="wp-bootblock">
							<div className="alert alert-warning alert-dismissible" role="alert">
								<InnerBlocks/>
								<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"/>
							</div>
						</div>
					</Block.div>
				</>
			)
		}

	},
	save: (props) => {
		const blockProps = useBlockProps.save()
		const id = props.attributes.id
		const height = props.attributes.height
		return (
			<div {...blockProps}>
				<div className="wp-bootblock">
					<div className="alert alert-warning alert-dismissible" role="alert">
						<InnerBlocks.Content/>
						<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"/>
					</div>
				</div>
			</div>
		)
	}
})
